import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query OAuthApplicationName($clientId: String!) {
    oauthApplicationName(clientId: $clientId)
  }
`;

export const queryOAuthApplicationName = (clientId, options = {}) =>
  executeGqlQuery({
    query: QUERY,
    variables: { clientId },
    options: { credentials: 'include', ...options },
  }).then(({ data }) => getSingleProp(data));
